import axios from "axios";

// Create the axios instance with baseURL
const authAxios = axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT,
    // baseURL : "http://ec2-15-207-132-85.ap-south-1.compute.amazonaws.com" , //qa,
    // baseURL : "https://adminapi.realopinions.ai/", // prod
    // baseURL:"https://wall.api.quiz.khiladiaddasupport.com", //qa test
    // baseURL : "http://localhost:4001" ,//local,
});

// Request interceptor to add the auth_token dynamically from localStorage
authAxios.interceptors.request.use(
    (config) => {
        try {
            const token = JSON.parse(localStorage.getItem("ss_token"));
            // If a token exists, attach it to the Authorization header
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }
        } catch (error) {
            // If token parsing fails, just continue without adding the header
            console.error('Token parsing error:', error);
        }
        
        return config;
    },
    
    (error) => {
        // Handle the error
        return Promise.reject(error);
    }
);

// Response interceptor to handle 401 errors
authAxios.interceptors.response.use(
    (config) => {
        return config;
    }, 
    
    (error) => {
        // Safely check for error response
        if (error?.response?.data) {
            const { status, message } = error.response.data;

            // Unauthorized user - redirect to login (only if not already on login page)
            if (status == 401) {
                localStorage.clear();
                if (window.location.pathname !== "/login") {
                    window.location.href = "/login";
                }
            }

            // Handle jwt malformed error (only if not already on login page)
            if (message == "jwt malformed") {
                localStorage.clear();
                if (window.location.pathname !== "/login") {
                    window.location.href = "/login";
                }
            }
        }

        return Promise.reject(error);
    }
);

export default authAxios;